var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"app-main",style:({ 'padding-top': _vm.needPadding ? '80px' : 0 })},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }